import { debounceTime, distinctUntilChanged, pipe } from 'rxjs';
// import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
// import { FormControl } from '@angular/forms';
// @Component({
//   selector: 'app-lazy-dropdown',
//   templateUrl: './lazy-dropdown.component.html',
//   styleUrls: ['./lazy-dropdown.component.scss']
// })
// export class LazyDropdownComponent implements OnInit {
//   @Input() label: string = 'University';
//   @Input() formControl: FormControl = new FormControl('');
//   @Input() items: any[] = [];
//   @Input() totalCount: number = 0;
//   @Input() offset: number = 0;
//   @Input() paginationLimit: number = 10;

//   @Output() loadMore: EventEmitter<void> = new EventEmitter<void>();
//   @Output() filterChange: EventEmitter<string> = new EventEmitter<string>();

//   filterControl = new FormControl('');

//   ngOnInit() {
//     this.filterControl.valueChanges.subscribe((value) => {
//       this.filterChange.emit(value);
//     });
//   }

//   onScroll() {
//     if (this.offset < this.totalCount) {
//       this.loadMore.emit();
//     }
//   }
// }


import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SearchEntity } from 'src/app/core/constants/dropdown-contants';

@Component({
  selector: 'app-lazy-dropdown',
  templateUrl: './lazy-dropdown.component.html',
  styleUrls: ['./lazy-dropdown.component.scss'],

})
export class LazyDropdownComponent implements OnInit {
  @Input() label: string;
  @Input() placeholder: string;
  @Input() class: string = '';
  @Input() items: any[] = [];
  @Input() totalCount: number = 0;
  @Input() offset: number = 0;
  @Input() paginationLimit: number = 50;
  @Input() multiple: boolean = false;
  @Input() showSelectAll: boolean = false;
  @Input() showClear: boolean = false;
  @Input() control: FormControl<any> = new FormControl(this.multiple ? [] : '');
  @Input('searchControl') searchControl: FormControl = new FormControl('');

  @Output() loadMore: EventEmitter<void> = new EventEmitter<void>();
  @Output() filterChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() selectionChange: EventEmitter<string> = new EventEmitter<string>();

  private _value: any;
  search_entiry = SearchEntity;

  // The function that will be called when the value is set on the form control
  private onChange: (value: any) => void = () => { };
  private onTouched: () => void = () => { };
  filterControl: any;

  get value(): any {
    return this._value;
  }

  set value(value: any) {
    this._value = value;
    this.onChange(value);
    this.onTouched();
  }

  // writeValue(value: any): void {
  //   this._value = value;
  //   this.formControl.setValue(value, { emitEvent: false }); // Ensure the formControl value is set correctly
  // }
  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  ngOnInit() {
    this.searchControl?.valueChanges?.pipe(
      distinctUntilChanged(),
      debounceTime(SearchEntity.debounce_time)).subscribe((value: string) => {
        this.filterChange.emit(value);
      });
  }

  onScroll() {
    this.loadMore.emit();

    // After loading new items, check if the value is still valid
    // if (this.formControl.value && !this.items.some(item => item.id === this.formControl.value)) {
    //   this.formControl.setValue(null);  // Reset or reselect the appropriate value
    // }
  }
  // onSelect(event: any) {
  //   if (this.multiple) {
 
  //     let currentValue = this.control.value || [];

  //     // If dealing with objects, compare by ID or another unique property
  //     const eventId = typeof event === 'object' ? event.id : event;
  //     const exists = currentValue.some(item =>
  //       (typeof item === 'object' ? item.id : item) === eventId
  //     );

  //     if (!exists) {
  //       currentValue.push(event);
  //     } else {
  //       currentValue = currentValue.filter(item =>
  //         (typeof item === 'object' ? item.id : item) !== eventId
  //       );
  //     }

  //     this.control.setValue([...currentValue]);
  //   } else {
  //     this.control.setValue(event);
  //   }    
  // }

  onSelect(event: any) {
    // if (this.multiple) {
    //   let currentValue = this.control.value || [];

    //   const existingIndex = currentValue.indexOf(event);

    //   if (existingIndex === -1) {
    //     currentValue.push(event);
    //   } else {
    //     currentValue.splice(existingIndex, 1);
    //   }

    //   this.control.setValue([...currentValue]);
    // } else {
    //   this.control.setValue(event);
    // }
  }

  onSelectionChange(event: any) {
    if(this.multiple){
      this.control.setValue(event.value);
    }
    this.selectionChange.emit(event);
  }


  // Function to toggle "Select All"
toggleSelectAll(event: any) {
  const isChecked = event.checked;
  if (isChecked) {
    const allItemIds = this.items.map(item => item.id);
    this.control.setValue(allItemIds);
  } else {
    this.control.setValue([]);
  }
}

// Handle item selection
  clearSelection(event: any) {
    this.control.setValue('');  // This clears the selected value
    this.selectionChange.emit(event);
  }

}

